import { prettyDate } from "../app/datetimeUtils";

export interface Props {
	date: Date | string;
}

export default function FormattedDate({ date }: Props) {
	if (typeof date === "string") {
		date = new Date(date);
	}
	const datestr = prettyDate(date);

	return <>{datestr}</>;
}
